import { SelectDropdown } from "../../types";
import { sectorsArray } from "../sectors";

export const sectorSelect: SelectDropdown = {
	selectName: 'sector',
	defaultValue: 'all',
	minWidth: 130,
	selectMenu: [{ value: 'all', label: 'כל המגזרים' }, ...sectorsArray?.map(({ id, value }) => ({ value: id, label: value }))]
};